// src/hooks/useGamesData.js
import { useContext } from "react";
import { GamesContext } from "../pages/context/GamesContext";
import Loader from "../components/Loader";

export const useGamesData = () => {
  const { gamesData, loading } = useContext(GamesContext);
  
  return { 
    gamesData, 
    loading, 
    LoaderComponent: loading ? <Loader /> : null 
  };
};